import React from 'react';
import { BookDemo } from '../bookDemoCommon/bookDemo';

interface IProp {
    referUrl: string;
}
interface ICmsProps {
    referUrl: string;
    platform: 'twww' | 'mobile'; // 平台
}
export function App(props: IProp) {
    const cmsInfo: ICmsProps = {
        referUrl: props.referUrl,
        platform: 'twww',
    };

    return <div className="cms-history-index-page">{<BookDemo {...cmsInfo}></BookDemo>}</div>;
}
